import { render, staticRenderFns } from "./RosterShiftDialog2.vue?vue&type=template&id=1dcdeb60&scoped=true&"
import script from "./RosterShiftDialog2.vue?vue&type=script&lang=js&"
export * from "./RosterShiftDialog2.vue?vue&type=script&lang=js&"
import style0 from "./RosterShiftDialog2.vue?vue&type=style&index=0&id=1dcdeb60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcdeb60",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VContainer,VForm,VList,VListItem,VListItemSubtitle,VListItemTitle,VMenu,VNavigationDrawer,VRow,VSheet,VSpacer,VToolbar,VToolbarTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcdeb60')) {
      api.createRecord('1dcdeb60', component.options)
    } else {
      api.reload('1dcdeb60', component.options)
    }
    module.hot.accept("./RosterShiftDialog2.vue?vue&type=template&id=1dcdeb60&scoped=true&", function () {
      api.rerender('1dcdeb60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/Ess/Roster/RosterFormRecord/components/RosterShiftDialog2.vue"
export default component.exports